import { Injectable, signal } from '@angular/core'

export interface Toast {
  type: 'success' | 'info' | 'warning' | 'error'
  message: string
  classname?: string
  delay?: number
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastItems = signal<Toast[]>([])
  readonly toasts = this.toastItems.asReadonly()

  show(toast: Toast) {
    this.toastItems.update((toasts) => [...toasts, toast])
  }

  remove(toast: Toast) {
    this.toastItems.update((toasts) => toasts.filter((item) => item !== toast))
  }

  clear() {
    this.toastItems.set([])
  }
}
